import { LockKeyhole, Store } from "lucide-react";
import { useState, type FormEvent } from "react";
import { api, setCsrfToken } from "../lib/api";

export function AuthPage({ bootstrapRequired, onAuthenticated }: { bootstrapRequired: boolean; onAuthenticated: () => void }) {
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault(); setBusy(true); setError("");
    const data = new FormData(event.currentTarget);
    try {
      const payload = bootstrapRequired
        ? { setupToken: data.get("setupToken"), name: data.get("name"), email: data.get("email"), password: data.get("password") }
        : { email: data.get("email"), password: data.get("password") };
      const result = await api<{ csrfToken: string }>(bootstrapRequired ? "/auth/bootstrap" : "/auth/login", { method: "POST", body: JSON.stringify(payload) });
      setCsrfToken(result.csrfToken); onAuthenticated();
    } catch (caught) { setError(caught instanceof Error ? caught.message : "Sign in failed."); }
    finally { setBusy(false); }
  }
  return <div className="auth-page"><section className="auth-panel">
    <div className="auth-brand"><div className="brand-mark large">R</div><div><strong>Razzi Order Desk</strong><span>Private staff workspace</span></div></div>
    <div className="auth-heading"><Store size={22} /><div><h1>{bootstrapRequired ? "Create owner account" : "Staff sign in"}</h1><p>{bootstrapRequired ? "Use the private setup code supplied during deployment." : "Use your Razzi staff account to continue."}</p></div></div>
    <form onSubmit={submit}>
      {bootstrapRequired && <><label>Full name<input name="name" autoComplete="name" required /></label><label>Setup code<input name="setupToken" type="password" required /></label></>}
      <label>Email<input name="email" type="email" autoComplete="email" required /></label>
      <label>Password<input name="password" type="password" minLength={bootstrapRequired ? 12 : 1} autoComplete={bootstrapRequired ? "new-password" : "current-password"} required /></label>
      {error && <p className="form-error">{error}</p>}
      <button className="button primary full" disabled={busy}><LockKeyhole size={17} />{busy ? "Please wait" : bootstrapRequired ? "Create owner account" : "Sign in"}</button>
    </form>
  </section></div>;
}
